const LOGIN_MFA_STORAGE_KEY = 'login_mfa_challenge';
export const MFA_RESEND_COOLDOWN_MS = 60 * 1000;

function expirationFromSeconds(seconds) {
  const parsedSeconds = Number(seconds);
  const duration = Number.isFinite(parsedSeconds) && parsedSeconds > 0 ? parsedSeconds : 600;
  return Date.now() + duration * 1000;
}

export function buildMfaChallenge(response) {
  if (!response?.challenge_token) return null;

  return {
    challengeToken: response.challenge_token,
    emailHint: response.email_hint || '',
    expiresAt: expirationFromSeconds(response.expires_in),
    resendAvailableAt: Date.now() + MFA_RESEND_COOLDOWN_MS,
    failedAttempts: 0,
  };
}

export function saveMfaChallenge(challenge) {
  if (!challenge?.challengeToken) return;
  sessionStorage.setItem(LOGIN_MFA_STORAGE_KEY, JSON.stringify(challenge));
}

export function loadMfaChallenge() {
  try {
    const stored = JSON.parse(sessionStorage.getItem(LOGIN_MFA_STORAGE_KEY));
    if (!stored?.challengeToken || !stored?.expiresAt || stored.expiresAt <= Date.now()) {
      clearMfaChallenge();
      return null;
    }
    return stored;
  } catch {
    clearMfaChallenge();
    return null;
  }
}

export function clearMfaChallenge() {
  sessionStorage.removeItem(LOGIN_MFA_STORAGE_KEY);
}
